import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { ThemeContext } from '../../contexts/ThemeContext';
import { authFetch } from '../../services/authFetch';

const LeaveForm = ({ onClose, initialData = null, readOnly = false, status = null, statusText = null }) => {
  const { darkMode } = useContext(ThemeContext);
  const [formData, setFormData] = useState({
    earlyleave_time: '',
    purpose: '',
    destination: '',
    pic: '',
    relationship: '',
    pic_contact_number: '',
    activity: 'Teori' // Default to 'Teori'
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: 'success' });

  // Load initial data if provided
  useEffect(() => {
    if (initialData) {
      setFormData({
        earlyleave_time: initialData.earlyleave_time || '',
        purpose: initialData.purpose || '',
        destination: initialData.destination || '',
        pic: initialData.pic || '',
        relationship: initialData.relationship || '',
        pic_contact_number: initialData.pic_contact_number || '',
        activity: initialData.activity || 'Teori'
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    if (readOnly) return;
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleActivityChange = (type) => {
    if (readOnly) return;
    setFormData({
      ...formData,
      activity: type
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (readOnly) {
      onClose();
      return;
    }
    setNotification({ show: false, message: '', type: 'success' });
    setLoading(true);
    // Prepare payload for API
    const payload = {
      earlyleave_time: formData.earlyleave_time,
      purpose: formData.purpose,
      destination: formData.destination,
      pic: formData.pic,
      relationship: formData.relationship,
      pic_contact_number: formData.pic_contact_number || undefined,
      activity: formData.activity
    };
    try {
      const response = await authFetch('/api/earlyleave_permits', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      const responseText = await response.clone().text();
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseErr) {
        setNotification({ show: true, message: 'Gagal mengurai respons server.', type: 'error' });
        setLoading(false);
        return;
      }
      if (!response.ok) {
        setNotification({ show: true, message: data.message || 'Gagal mengirim permohonan pulang awal.', type: 'error' });
      } else {
        setNotification({ show: true, message: data.message || 'Permohonan Pulang Awal berhasil diajukan!', type: 'success' });
        setFormData({
          earlyleave_time: '',
          purpose: '',
          destination: '',
          pic: '',
          relationship: '',
          pic_contact_number: '',
          activity: 'Teori'
        });
        // Close the popup after a short delay if success
        if (onClose) {
          setTimeout(() => {
            onClose();
          }, 2000);
        }
      }
    } catch (err) {
      setNotification({ show: true, message: 'Terjadi kesalahan jaringan.', type: 'error' });
    }
    setLoading(false);
  };

  
  return (
    <>
      {notification.show && (
        <NotificationToast $type={notification.type}>
          <NotificationMessage>{notification.message}</NotificationMessage>
          <CloseNotificationButton onClick={() => setNotification({ ...notification, show: false })}>
            ×
          </CloseNotificationButton>
        </NotificationToast>
      )}
      <FormWrapper theme={darkMode ? 'dark' : 'light'}>
      <FormHeader>
        <HeaderContent>
          <h2>Formulir Permohonan Pulang Awal</h2>
          {status && (
            <StatusBadge status={status}>
              {statusText}
            </StatusBadge>
          )}
        </HeaderContent>
        <CloseButton onClick={onClose}>×</CloseButton>
      </FormHeader>
      
      <FormContent>
        <form onSubmit={handleSubmit}>
          <TypeToggleContainer>
            <TypeToggleLabel>Saat ini sedang apa?</TypeToggleLabel>
            <TypeToggleButtonGroup>
              <TypeToggleButton 
                type="button" 
                active={formData.activity === 'Teori' ? 'true' : 'false'}
                onClick={() => handleActivityChange('Teori')}
                disabled={readOnly}
              >
                Teori
              </TypeToggleButton>
              <TypeToggleButton 
                type="button" 
                active={formData.activity === 'Praktek' ? 'true' : 'false'}
                onClick={() => handleActivityChange('Praktek')}
                disabled={readOnly}
              >
                Praktek
              </TypeToggleButton>
            </TypeToggleButtonGroup>
          </TypeToggleContainer>
          
          <FormGroup theme={darkMode ? 'dark' : 'light'}>
            <label htmlFor="earlyleave_time">Pulang jam berapa</label>
<input
  type="time"
  id="earlyleave_time"
  name="earlyleave_time"
  value={formData.earlyleave_time}
  onChange={handleChange}
  required
  readOnly={readOnly}
  disabled={readOnly}
/>
          </FormGroup>
          
          <FormGroup theme={darkMode ? 'dark' : 'light'}>
            <label htmlFor="purpose">Ada keperluan apa</label>
            <textarea
              id="purpose"
              name="purpose"
              rows="3"
              value={formData.purpose}
              onChange={handleChange}
              placeholder="Tuliskan alasan/keperluan pulang awal"
              required
              readOnly={readOnly}
              disabled={readOnly}
            ></textarea>
          </FormGroup>
          
          <FormGroup theme={darkMode ? 'dark' : 'light'}>
            <label htmlFor="destination">Nama tempat dan alamat tujuan</label>
            <textarea
              id="destination"
              name="destination"
              rows="2"
              value={formData.destination}
              onChange={handleChange}
              placeholder="Contoh: Rumah, Jl. Pahlawan No. 10"
              required
              readOnly={readOnly}
              disabled={readOnly}
            ></textarea>
          </FormGroup>
          
          <FormRow>
            <FormGroup theme={darkMode ? 'dark' : 'light'}>
              <label htmlFor="pic">Nama penanggungjawab</label>
<input
  type="text"
  id="pic"
  name="pic"
  value={formData.pic}
  onChange={handleChange}
  placeholder="Contoh: Budi Santoso"
  required
  readOnly={readOnly}
  disabled={readOnly}
/>
            </FormGroup>
            
            <FormGroup theme={darkMode ? 'dark' : 'light'}>
              <label htmlFor="relationship">Hubungan</label>
              <input
                type="text"
                id="relationship"
                name="relationship"
                value={formData.relationship}
                onChange={handleChange}
                placeholder="Contoh: Orang tua, Wali, Saudara"
                required
                readOnly={readOnly}
                disabled={readOnly}
              />
            </FormGroup>
          </FormRow>
          
          <FormGroup theme={darkMode ? 'dark' : 'light'}>
            <label htmlFor="pic_contact_number">Nomor telepon penanggungjawab <span style={{color:'#888',fontWeight:400}}>(opsional)</span></label>
<input
  type="tel"
  pattern="[0-9]*"
  inputMode="numeric"
  id="pic_contact_number"
  name="pic_contact_number"
  value={formData.pic_contact_number}
  onChange={e => {
    // Only allow digits
    if (/^\d*$/.test(e.target.value)) handleChange(e);
  }}
  placeholder="Contoh: 081234567890"
  readOnly={readOnly}
  disabled={readOnly}
/>
          </FormGroup>
          
          <NoteBox>
            <NoteIcon>ℹ️</NoteIcon>
            <NoteText>Catatan: Siswa wajib membawa surat keterangan dari penanggungjawab dan diserahkan ke pamong ketika kembali.</NoteText>
          </NoteBox>
          
          <FormActions>
            <CancelButton type="button" onClick={onClose}>
              {readOnly ? 'Tutup' : 'Batal'}
            </CancelButton>
            {!readOnly && (
              <SubmitButton type="submit">Kirim Permohonan</SubmitButton>
            )}
          </FormActions>
        </form>
      </FormContent>
    </FormWrapper>
    </>
  );
};

const FormWrapper = styled.div`
  background-color: var(--background);
  border-radius: 16px;
  overflow: hidden;
  transition: background-color 0.3s;
`;

const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid var(--border);
  
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--text-dark);
    margin: 0;
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  
  ${props => {
    switch(props.status) {
      case 'approved':
        return `
          background-color: #e6f8f5;
          color: #00a389;
        `;
      case 'pending':
        return `
          background-color: #fff3e0;
          color: #ff9800;
        `;
      case 'rejected':
        return `
          background-color: #feeeee;
          color: #dc3545;
        `;
      default:
        return '';
    }
  }}
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: var(--text-light);
  
  &:hover {
    background-color: var(--background-light);
  }
`;

const FormContent = styled.div`
  padding: 1.5rem;
  
  form {
    max-width: 800px;
    margin: 0 auto;
  }
  
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--text-dark);
  }
  
  input, select, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    color: var(--text-dark);
    background-color: ${props => props.theme === 'dark' ? '#383838' : '#f5f5f5'};
    
    &:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 2px rgba(43, 93, 161, 0.2);
    }
  }
  
  textarea {
    resize: vertical;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  
  ${FormGroup} {
    flex: 1;
    margin-bottom: 0;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

const NoteBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background-color: rgba(43, 93, 161, 0.1);
  border-radius: 8px;
  margin-bottom: 1.5rem;
`;

const NoteIcon = styled.div`
  font-size: 1.25rem;
`;

const NoteText = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-dark);
`;

const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

const SubmitButton = styled.button`
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: var(--primary-light);
  }
`;

const CancelButton = styled.button`
  background-color: transparent;
  color: var(--text-dark);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: var(--background-light);
  }
`;

// Notification Toast styles (copied from InterupsiForm.js for consistency)
const NotificationToast = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  min-width: 300px;
  background-color: ${props => props.$type === 'success' ? '#2ecc71' : '#e74c3c'};
  color: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  animation: slideIn 0.3s ease-out forwards;
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
`;
const NotificationMessage = styled.div`
  flex: 1;
  font-weight: 500;
`;
const CloseNotificationButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-left: 10px;
  opacity: 0.8;
  transition: opacity 0.2s;
  &:hover { opacity: 1; }
`;

const TypeToggleContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const TypeToggleLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-dark);
`;

const TypeToggleButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const TypeToggleButton = styled.button`
  background-color: ${props => props.active === 'true' ? 'var(--primary)' : 'var(--background)'};
  color: ${props => props.active === 'true' ? 'white' : 'var(--text-dark)'};
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.active === 'true' ? 'var(--primary-light)' : 'var(--background-light)'};
  }
`;

export default LeaveForm;